import Store from "@/store/index.js";
import axios from 'axios'
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
const domain = Store.state.domain;

export default {
    EstadoAsistencia() {
        return axios.post(`${domain.domainNameForApi}Asistencia/EstadoAsistencia`).then(response => response.data);
    },
    registrarAsistencia(data) {
        return axios.post(`${domain.domainNameForApi}Asistencia/registrarAsistencia`, data).then(response => response.data);
    },
}